var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19C10.4477 19 10 19.4477 10 20C10 20.5523 10.4477 21 11 21H29C29.5523 21 30 20.5523 30 20C30 19.4477 29.5523 19 29 19H11Z",
    fill: "url(#paint0_angular_410_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15H11C10.4477 15 10 14.5523 10 14C10 13.4477 10.4477 13 11 13H29C29.5523 13 30 13.4477 30 14C30 14.5523 29.5523 15 29 15Z",
    fill: "url(#paint1_angular_410_167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27H11C10.4477 27 10 26.5523 10 26C10 25.4477 10.4477 25 11 25H29C29.5523 25 30 25.4477 30 26C30 26.5523 29.5523 27 29 27Z",
    fill: "url(#paint2_angular_410_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_410_167",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(1 10)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.256361,
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620951,
    stopColor: "#D05DDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_410_167",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 14) rotate(90) scale(1 10)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.256361,
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620951,
    stopColor: "#D05DDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_410_167",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 26) rotate(90) scale(1 10)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.256361,
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620951,
    stopColor: "#D05DDE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.162fb1f807e752b636bb49442f340690.svg";
export { ForwardRef as ReactComponent };